<style>
.base-print-label {
  width: 110px;
}
</style>
<style scope="scope">
.printTemp {
  font-family: 'Microsoft YaHei', Arial, sans-serif !important;
  /* font-family: '宋体'; */
}

.printTemp .el-table--border,
.el-table--group {
  border: 1px solid black;
}

.editBorder {
  border: 1px dashed #666;
  padding: 10px;
}

.el-input>>>.el-input__inner {
  font-family: 'Microsoft' !important;
  font-size: 20px !important;
}
</style>

<template>
  <div class="printTemp" style="width:100%">
    <div style="width:100%;display:flex;justify-content:center;color:black">
      <el-input v-if="!order" style="width:300px;text-align:center" v-model="printTem.title"></el-input>
      <div v-if="order" style="width:100%;text-align:center;font-size:24px;color: black;">
        {{ printTem.title }}
      </div>
    </div>
    <div style="display:flex;padding:10px 0px;justify-content: flex-end;width:100%">
      <el-button v-if="!order" size="mini" icon="yicon yicon-config_column" :title="$t('peizhi')" @click="
        isShowJibenDialog = true;
      showColumnsDialog('base');
      "></el-button>
    </div>
    <el-descriptions title="" :column="2" :size="'mini'">
      <el-descriptions-item labelStyle="color:black;font-size:14px" contentStyle="color:black;font-size:14px" v-for="key in printTem.baseValues" :label="$t(key)">{{ order ? order[key] : '' }}</el-descriptions-item>
    </el-descriptions>
    <div style="display:flex;padding:10px 0px;justify-content: flex-end;width:100%">
      <el-button v-if="!order" size="mini" icon="yicon yicon-config_column" :title="$t('peizhi')" @click="
        isShowMingxiDialog = true;
      showColumnsDialog('detail');
      "></el-button>
    </div>
    <el-table class="printTempTable" :cell-style="{ color: 'black', 'border-color': 'black' }" :header-cell-style="{ color: 'black', 'font-weight': 'normal', 'border-color': 'black' }" :data="order ? order.details : []" border style="width: 100%;margin-top:0px">
      <el-table-column v-for="key in printTem.detailValues" :prop="key" :label="$t(key)"> </el-table-column>
    </el-table>

    <div style="display:flex;padding:10px 0px;justify-content: flex-end;width:100%">
      <el-popover v-if="!order" placement="top" width="160" v-model="signVisible">
        <el-input size="mini" v-model="signText"></el-input>
        <div style="text-align: right; margin-top: 10px">
          <el-button size="mini" type="text" @click="signVisible = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" @click="
        addSign();
      signVisible = false;
      ">{{ $t('queding') }}</el-button>
        </div>
        <el-button slot="reference" size="mini" :title="$t('peizhilie')">{{ $t('xinzeng') }}</el-button>
      </el-popover>
    </div>
    <div style="margin-top:0px;width: 100%;display:grid;grid-template-columns:1fr 1fr ;grid-gap: 20px 20px;">
      <div v-for="(label, index) in printTem.sign" style="position:relative;">
        <div v-if="!order" @click="deleteSign(index)" style="color:white;display:flex;justify-content:center;background:#f56c6c;border-radius:50%;width:22px;height:22px;position: absolute;top:-4px;right:-4px">
          x
        </div>
        <div style="display:flex;width:100%;" :class="[!order ? 'editBorder' : '']">
          <div style="color:black">{{ label }}</div>
          <div style="width:210px;border-bottom: 1px black solid;"></div>
        </div>
      </div>
    </div>

    <el-dialog :show-close="true" :title="$t('jibenxinxi')" :visible.sync="isShowJibenDialog" :width="'720px'" :close-on-click-modal="false" append-to-body>
      <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
        <el-transfer target-order="push" key="base" ref="base" v-model="printTem.baseValues" :data="printTem.base"></el-transfer>
      </div>
    </el-dialog>
    <el-dialog :show-close="true" :title="$t('mingxixinxi')" :visible.sync="isShowMingxiDialog" :width="'720px'" :close-on-click-modal="false" append-to-body>
      <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
        <el-transfer target-order="push" key="detail" ref="detail" v-model="printTem.detailValues" :data="printTem.detail"></el-transfer>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Sortable from 'sortablejs';
export default {
  name: 'web_base_print_template_without_out',
  props: {
    config: {
      type: String,
      default: '{}'
    },
    order: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isShowJibenDialog: false,
      isShowMingxiDialog: false,
      outOrderNoShow:false,
      printTem: {
        title: this.$t('wudanchukudan'),
        baseValues: ['kehumingcheng', 'danjuleixing', 'beizhu'],
        base: [
          {
            key: 'kehumingcheng',
            label: this.$t('kehumingcheng'),
            width: '50%'
          },
          {
            key: 'kehudizhi',
            label: this.$t('kehudizhi'),
            width: '50%'
          },
          {
            key: 'kehulianxiren',
            label: this.$t('kehulianxiren'),
            width: '50%'
          },
          {
            key: 'kehudianhua',
            label: this.$t('kehudianhua'),
            width: '50%'
          },
          {
            key: 'danjuleixing',
            label: this.$t('danjuleixing'),
            width: '50%'
          },
          {
            key: 'beizhu',
            label: this.$t('beizhu'),
            width: '50%'
          },
          {
            key: 'shenhezhuangtai',
            label: this.$t('shenhezhuangtai'),
            width: '50%'
          },
          {
            key: 'chukudanhao',
            label: this.$t('chukudanhao'),
            width: '50%'
          },
          {
            key: 'chuangjianren',
            label: this.$t('chuangjianren'),
            width: '50%'
          },
          {
            key: 'shenheren',
            label: this.$t('shenheren'),
            width: '50%'
          },
          {
            key: 'danjuriqi',
            label: this.$t('danjuriqi'),
            width: '50%'
          }
        ],
        detailValues: ['wuliaobianma', 'wuliaomingcheng', 'wuliaopicihao', 'danwei', 'chukushuliang', 'mingxizhuangtai', 'shichushuliang', 'beizhu'],
        detail: [
          {
            key: 'wuliaobianma',
            label: this.$t('wuliaobianma')
          },
          {
            key: 'wuliaomingcheng',
            label: this.$t('wuliaomingcheng')
          },
          {
            key: 'wuliaopicihao',
            label: this.$t('wuliaopicihao')
          },
          {
            key: 'danwei',
            label: this.$t('danwei')
          },
          {
            key: 'chukushuliang',
            label: this.$t('chukushuliang')
          },
          {
            key: 'mingxizhuangtai',
            label: this.$t('mingxizhuangtai')
          },
          {
            key: 'shichushuliang',
            label: this.$t('shichushuliang')
          },
          {
            key: 'beizhu',
            label: this.$t('beizhu')
          }
        ],
        sign: [this.$t('cangkuqianzi')]
      },
      signVisible: false,
      signText: ''
    };
  },
  created() {
    this.checkIsShowoutOrderNo();
    if (this.order) {
      this.order.gongyingshangmingcheng = this.order.supplier ? this.order.supplier.name : '';
      this.order.kehumingcheng = this.order.wmsCustomer ? this.order.wmsCustomer.name : '';
      this.order.kehudizhi = this.order.wmsCustomer ? this.order.wmsCustomer.address : '';
      this.order.kehulianxiren = this.order.wmsCustomer ? this.order.wmsCustomer.contacts : '';
      this.order.kehudianhua = this.order.wmsCustomer ? this.order.wmsCustomer.contactsInfo : '';
      this.order.danjuleixing = this.$t('wudanchuku');
      this.order.beizhu = this.order.remark;
      this.order.shenhezhuangtai = this.order.checkStatus == 0 ? this.$t('daishenhe') : this.$t('yishenhe');
      this.order.chukudanhao = this.order.no;
      this.order.chuangjianren = this.order.createByObject.nickname;
      this.order.shenheren = this.order.checkUserObject.nickname;
      this.order.danjuriqi = this.order.billDate ? this.dayjs.unix(this.order.billDate / 1000).format('YYYY-MM-DD') : '';

      for (var i = 0; i < this.order.details.length; i++) {
        this.order.details[i].wuliaobianma = this.order.details[i].material.code;
        this.order.details[i].wuliaomingcheng = this.order.details[i].material.name;
        this.order.details[i].wuliaopicihao = this.order.details[i].materialBatchNo;
        this.order.details[i].danwei = this.store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][this.order.details[i].unit];
        this.order.details[i].chukushuliang = this.order.details[i].quantity;
        this.order.details[i].mingxizhuangtai = this.order.details[i].status == 0 ? this.$t('weichuku') : this.order.details[i].status == 1 ? this.$t('bufenchuku') : this.$t('quanbuchuku');
        this.order.details[i].shichushuliang = this.order.details[i].actualQuantity;
        this.order.details[i].beizhu = this.order.details[i].remark;
        if(this.outOrderNoShow) {
          this.order.details[i].chukudanhao = this.order.details[i].remark;
        }
      }
    }

    if (this.config == '{}' || this.config == null) {
      // this.printTem.baseValues = this.printTem.base.map(item => {
      // 	return item.key
      // })
      // this.printTem.detailValues = this.printTem.detail.map(item => {
      // 	return item.key
      // })
    } else {
      let cfg = JSON.parse(this.config);
      if(this.outOrderNoShow) {
        this.printTem.detail.push({ key: 'chukudanhao', label: this.$t('chukudanhao')});
      }
      // 数据库中的配置
      let baseArr = cfg.base || [];
      let baseValuesArr = cfg.baseValues || [];
      let basekeys = baseArr.map(e => e.key).concat(baseValuesArr);
      // 本地配置
      let baseArr2 = this.printTem.base || [];
      let baseValuesArr2 = this.printTem.baseValues || [];
      let basekeys2 = baseArr2.map(e => e.key).concat(baseValuesArr2);

      // 将本地配置中多出的配置项添加到数据库配置中的base里面, 以免新添加的字段在已有的模板中配置不了
      let baseKs = basekeys2.filter(item => !basekeys.includes(item));
      for (let i = 0; i < baseKs.length; i++) {
        baseArr = baseArr.concat(baseArr2.filter(e => e.key === baseKs[i]));
      }
      cfg.base = baseArr;

      // 数据库中的配置
      let detailArr = cfg.detail || [];
      let detailValuesArr = cfg.detailValues || [];
      let detailKeys = detailArr.map(e => e.key).concat(detailValuesArr);
      // 本地配置
      let detailArr2 = this.printTem.detail || [];
      let detailValuesArr2 = this.printTem.detailValues || [];
      let detailKeys2 = detailArr2.map(e => e.key).concat(detailValuesArr2);

      // 将本地配置中多出的配置项添加到数据库配置中的detail里面, 以免新添加的字段在已有的模板中配置不了
      let detailKs = detailKeys2.filter(item => !detailKeys.includes(item));
      for (let i = 0; i < detailKs.length; i++) {
        detailArr = detailArr.concat(detailArr2.filter(e => e.key === detailKs[i]));
      }
      cfg.detail = detailArr;
      this.printTem = cfg;
    }
  },

  methods: {
    deleteSign(index) {
      this.printTem.sign.splice(index, 1);
    },
    addSign() {
      if (this.signText == '') {
        this.utils.errorMessage(this.$t('bunengweikong'));
        return;
      }
      this.printTem.sign.push(this.signText);
      this.signVisible = false;
      this.signText = '';
    },
    showColumnsDialog(type) {
      this.$nextTick(() => {
        this.initColumnsTransfer(type);
      });
    },
    initColumnsTransfer(type) {
      const transfer = this.$refs[type].$el;
      const leftPanel = transfer.getElementsByClassName('el-transfer-panel')[0].getElementsByClassName('el-transfer-panel__body')[0];
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0];
      const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0];
      Sortable.create(rightEl, {
        animation: 100,
        filter: '.ignore-elements',
        onEnd: evt => {
          const { oldIndex, newIndex } = evt;
          console.log(111);
          if (type == 'base') {
            const temp = this.printTem.baseValues[oldIndex];
            if (!temp || temp === 'undefined') {
              return;
            } // 解决右边最后一项从右边拖左边，有undefined的问题
            //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
            //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
            //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
            // 去除空字符串
            for (var i = 0; i < this.printTem.baseValues.length; i++) {
              if (this.printTem.baseValues[i] === '' || this.printTem.baseValues[i] === null || typeof this.printTem.baseValues[i] === 'undefined') {
                this.printTem.baseValues.splice(i, 1);
                i = i - 1;
              }
            }
            const arr_temp = [].concat(this.printTem.baseValues); // 创建一个新的临时数组，用以操作后不变更原数组
            arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素
            this.printTem.baseValues = arr_temp;
          } else {
            const temp = this.printTem.detailValues[oldIndex];
            if (!temp || temp === 'undefined') {
              return;
            } // 解决右边最后一项从右边拖左边，有undefined的问题
            //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
            //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
            //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
            // 去除空字符串
            for (var i = 0; i < this.printTem.detailValues.length; i++) {
              if (this.printTem.detailValues[i] === '' || this.printTem.detailValues[i] === null || typeof this.printTem.detailValues[i] === 'undefined') {
                this.printTem.detailValues.splice(i, 1);
                i = i - 1;
              }
            }
            const arr_temp = [].concat(this.printTem.detailValues); // 创建一个新的临时数组，用以操作后不变更原数组
            arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素
            this.printTem.detailValues = arr_temp;
          }

          //保存
          //this.showColumnsChange()
        }
      });

      rightPanel.ondragover = ev => {
        ev.preventDefault();
      };
      rightPanel.ondrop = ev => {
        ev.preventDefault();
        if (type == 'base') {
          if (this.printTem.baseValues.indexOf(this.draggingKey) === -1) {
            this.printTem.baseValues.push(this.draggingKey);
          }
        } else {
          if (this.printTem.detailValues.indexOf(this.draggingKey) === -1) {
            this.printTem.detailValues.push(this.draggingKey);
          }
        }
      };
    },

    drag(ev, option) {
      this.draggingKey = option.key;
    },

    checkIsShowoutOrderNo() {
      for (let index = 0; index < this.store.state.customerTableFields.length; index++) {
        if (this.store.state.customerTableFields[index].tableId == 'web_base_print_template_out_kaisu') {
          this.outOrderNoShow = true;
        }
      }
    },
  }
};
</script>
